export default __webpack_public_path__ + "static/media/solucao-10.22a0705c.webp";